import { Link } from "react-router-dom";

const categoryData = [
  {
    id: "power-tools",
    name: "Power Tools",
    count: 12,
    image: "https://public.readdy.ai/ai/img_res/ff497b93f438e4fa959dae65672ec151.jpg",
  },
  {
    id: "hand-tools",
    name: "Hand Tools",
    count: 8,
    image: "https://readdy.ai/api/search-image?query=professional%20hand%20tools%20wrenches%20pliers%20hammers%20screwdrivers%20organized%20on%20dark%20workshop%20background%2C%20dramatic%20lighting%2C%20professional%20photography&width=600&height=400&seq=cat002&orientation=landscape",
  },
  {
    id: "measuring",
    name: "Measuring Tools",
    count: 4,
    image: "https://readdy.ai/api/search-image?query=professional%20measuring%20tools%20tape%20measure%20laser%20level%20multimeter%20on%20dark%20background%2C%20dramatic%20lighting%2C%20professional%20photography&width=600&height=400&seq=cat003&orientation=landscape",
  },
  {
    id: "fasteners",
    name: "Fasteners",
    count: 2,
    image: "https://readdy.ai/api/search-image?query=professional%20drill%20bits%20fasteners%20hardware%20accessories%20organized%20on%20dark%20industrial%20background%2C%20dramatic%20lighting%2C%20professional%20photography&width=600&height=400&seq=cat004&orientation=landscape",
  },
  {
    id: "safety",
    name: "Safety Equipment",
    count: 3,
    image: "https://readdy.ai/api/search-image?query=professional%20safety%20equipment%20hard%20hat%20safety%20glasses%20gloves%20on%20dark%20background%2C%20dramatic%20lighting%2C%20professional%20photography&width=600&height=400&seq=cat005&orientation=landscape",
  },
  {
    id: "storage",
    name: "Storage Solutions",
    count: 3,
    image: "https://readdy.ai/api/search-image?query=professional%20tool%20storage%20chest%20cabinet%20organizer%20on%20dark%20workshop%20background%2C%20dramatic%20lighting%2C%20professional%20photography&width=600&height=400&seq=cat006&orientation=landscape",
  },
];

const CategoriesSection: React.FC = () => (
  <section className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 md:px-6">
      <div className="text-center mb-12">
        <p className="text-orange-500 text-sm font-semibold uppercase tracking-widest mb-2">Browse by Category</p>
        <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
          Find the Right Tool
        </h2>
        <p className="text-gray-500 text-lg max-w-xl mx-auto">
          Six specialized categories covering everything from power tools to safety equipment
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {categoryData.map((cat, index) => (
          <Link
            key={cat.id}
            to={`/products?category=${cat.id}`}
            className={`group relative overflow-hidden rounded-xl cursor-pointer ${
              index === 0 ? "sm:col-span-2 lg:col-span-1" : ""
            }`}
            style={{ height: index < 2 ? "280px" : "220px" }}
          >
            <img
              src={cat.image}
              alt={cat.name}
              className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <h3 className="text-white text-xl font-bold mb-1">{cat.name}</h3>
              <div className="flex items-center justify-between">
                <span className="text-white/70 text-sm">{cat.count} Products</span>
                <span className="flex items-center gap-1 text-orange-400 text-sm font-medium group-hover:gap-2 transition-all">
                  Shop Now <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default CategoriesSection;
